import React from 'react';
import { PolicySummaryFacade } from '~domain/model/facade/policy/policy-summary-facade';
import { PolicyCardsGrid } from '~frontend-common/components/policy-cards-grid';
import { useHistory } from '~frontend-common/hooks/use-history';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box/box';
import { Typography } from '~ui-kit/components/typography';
import { theme } from '~ui-kit/theme';
import { Images } from '~web-portal/theme/images';

interface ActivePoliciesProps {
  policies: PolicySummaryFacade[];
}

export function ActivePolicies({ policies = [] }: ActivePoliciesProps) {
  const { tl } = useTranslator();
  const history = useHistory();

  const handleModifyPolicy = (policy: PolicySummaryFacade) => {
    history.push(`/policies/${policy.id}`);
  };

  const handleDocuments = (policy: PolicySummaryFacade) => {
    history.push(`/policies/${policy.id}/documents`);
  };

  if ((policies || []).length === 0) {
    return (
      <Box flexDirection="column" alignItems="center" justifyContent="center" minHeight="10vh">
        <Typography $color={theme.colors.gray}>{tl('policyPages.activePolicies.empty')}</Typography>
      </Box>
    );
  }

  return (
    <PolicyCardsGrid
      $mt={[4, 4, '48px']}
      policies={policies}
      images={Images}
      onModifyPolicy={handleModifyPolicy}
      onDocumentsClicked={handleDocuments}
    />
  );
}
